import dateUtil from "@/utils/date.js"

export const monCompteAbonnementOverviewProps = () => ({
  abonnement: {
    type: Object,
    required: true
  }
})

export const useMonCompteAbonnementOverview = (props) => {
  const badgeColor = computed(() => {
    return props.abonnement.attributes.en_cours ? "green" : "grey-2"
  })
  const dateFin = computed(() => {
    return dateUtil.formatDateMonth(props.abonnement.attributes.date_fin);
  })

  return {
    badgeColor,
    dateFin
  }
}